export const Messages = {
  LOGIN_SUCCESS: 'Login successful',
  LOGIN_ERROR: 'Login failed',
  LOGOUT_SUCCESS: 'Logout successful',
  REFRESH_TOKEN_SUCCESS: 'Token refreshed successfully',
  REFRESH_TOKEN_ERROR: 'Failed to refresh token',
  UPDATE_SUCCESS: 'Update successful',
  UPDATE_ERROR: 'Update failed',
  FETCH_PROFILE_SUCCESS: 'Profile fetched successfully',
  FETCH_PROFILE_ERROR: 'Failed to fetch profile',
  INVALID_CREDENTIALS: 'Invalid username or password',
  NETWORK_ERROR: 'Network error',
  API_ERROR: 'System error. Please contact the administrator',
  CREATE_SUCCESS: 'Created successfully',
  REGISTER_SUCCESS: 'Registered successfully',
  REVOKE_SUCCESS: 'Revoke successfully',
  DELETE_SUCCESS: 'Delete successfully',
  CONFIRM_SUCCESS: 'Confirm successfully',
  CHANGE_ROLE_SUCCESS: 'Change Role successfully',
  INVITE_SUCCESS: 'Invite sent successfully',
  ASSIGN_SUCCESS: 'Invite sent successfully',
} as const;
